export default "__VITE_ASSET__CprG9ach__"